// extracted by mini-css-extract-plugin
export var createdDate = "_h1-1";
export var divider = "_h1-2";
export var headerDivider = "_h1-3";
export var messagesCard = "_h1-0";
export var messagesContainer = "_h1-7";
export var messagesContainerWrapper = "_h1-4";
export var pointerCapturingButtonBoxes = "_h1-a";
export var showLeftPanelButton = "_h1-9";
export var showMoreButton = "_h1-c";
export var showMoreButtonContainer = "_h1-b";
export var summaryTitle = "_h1-6";
export var systemMessageCardWrapper = "_h1-d";
export var topButtons = "_h1-8";
export var withPadding = "_h1-5";